<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body" [formGroup]="form">
  <div class="col row mb-3">
    <label class="form-label col-12 align-self-center">ชื่อรายการ:</label>
    <div class="col-12">
      <input type="text" class="form-control" formControlName="equipmentCustomName" [disabled]="!isView"
             [ngClass]="{'is-invalid': isFormInvalid('equipmentCustomName')}" />
    </div>
  </div>
  <ng-container *ngIf="!isMultipleEquipment">
    <div class="col row mb-3">
      <label class="form-label col-12 align-self-center">หมายเลข/ทะเบียน:</label>
      <div class="col-12">
        <input type="text" class="form-control" formControlName="equipmentNumber" [disabled]="!isView"
               [ngClass]="{'is-invalid': isFormInvalid('equipmentNumber')}" />
      </div>
    </div>
    <div class="col row mb-3">
      <div class="col-6">
        <label class="form-label col-md-12 align-self-center">ปีงบประมาณ</label>
        <ng-select class="custom" [items]="fiscalYear$ | async" bindLabel="title" bindValue="id"
                   placeholder="กรุณาเลือก" formControlName="fiscalYearId" [searchable]="true" [clearable]="false"
                   [ngClass]="{'is-invalid': isFormInvalid('fiscalYearId')}"
                   [disabled]="!isView">
        </ng-select>
      </div>
      <div class="col-6">
        <label class="form-label col-12 align-self-center">วันที่รับเข้า</label>
        <div class="col-12">
          <input type="text" class="form-control"
                 placeholder="กรุณาเลือก"
                 bsDatepicker
                 formControlName="receiveDate"
                 [bsConfig]="{ dateInputFormat: 'DD MMMM YYYY' }"
                 [ngClass]="{'is-invalid': isFormInvalid('receiveDate')}"
                 [disabled]="!isView" />
        </div>
      </div>
    </div>
    <div class="col row mb-3" *ngIf="isParcel">
      <div class="col-6">
        <label class="form-label col-md-12 align-self-center">ประเภทการจัดซื้อจัดจ้าง</label>
        <ng-select class="custom" [items]="procurementType$ | async" bindLabel="title" bindValue="id"
                   placeholder="กรุณาเลือก" formControlName="procurementTypeId" [searchable]="true" [clearable]="false"
                   [ngClass]="{'is-invalid': isFormInvalid('procurementTypeId')}"
                   [disabled]="!isView">
        </ng-select>
      </div>
      <div class="col-6">
        <label class="form-label col-12 align-self-center">เลขที่สัญญา</label>
        <div class="col-12">
          <input type="text" class="form-control" formControlName="contractNo" [disabled]="!isView"
                 [ngClass]="{'is-invalid': isFormInvalid('contractNo')}" />
        </div>
      </div>
    </div>
    <div class="col row mb-3" *ngIf="isParcel">
      <div class="col-6">
        <label class="form-label col-md-12 align-self-center">ลงวันที่</label>
        <input type="text" class="form-control"
               placeholder="กรุณาเลือก"
               bsDatepicker
               formControlName="dated"
               [bsConfig]="{ dateInputFormat: 'DD MMMM YYYY' }"
               [ngClass]="{'is-invalid': isFormInvalid('dated')}"
               [disabled]="!isView" />
      </div>
      <div class="col-6">
        <label class="form-label col-12 align-self-center">เลขสินทรัพย์ในระบบ GFMIS</label>
        <div class="col-12">
          <input type="text" class="form-control" formControlName="assetNoGfmis" [disabled]="!isView"
                 [ngClass]="{'is-invalid': isFormInvalid('assetNoGfmis')}" />
        </div>
      </div>
    </div>
    <div class="col row mb-3" *ngIf="isParcel">
      <div class="col-6">
        <label class="form-label col-md-12 align-self-center">ราคาต่อหน่วย</label>
        <input type="text" class="form-control" formControlName="pricePerUnit" [disabled]="!isView"
               [ngClass]="{'is-invalid': isFormInvalid('pricePerUnit')}" />
      </div>
      <div class="col-6">
        <label class="form-label col-12 align-self-center">งวดงาน/งวดงานทั้งหมด</label>
        <div class="col-12">
          <input type="text" class="form-control" formControlName="workPeriod" [disabled]="!isView"
                 [ngClass]="{'is-invalid': isFormInvalid('workPeriod')}" />
        </div>
      </div>
    </div>
    <div class="col row">
      <div class="col-6">
        <label for="isActive" class="form-label">{{titleStatus}}</label>
        <div class="col-12">
          <ng-select class="custom" [items]="sharedService.manageParcalStatus" bindLabel="label" bindValue="value"
                     placeholder="กรุณาเลือก" [searchable]="true" [clearable]="true"
                     formControlName="equipmentStatus"
                     [ngClass]="{'is-invalid': isFormInvalid('equipmentStatus')}"
                     [disabled]="!isView">
          </ng-select>
        </div>
      </div>
      <div class="col-6">
        <label for="isActive" class="form-label">สถานะการใช้งาน</label>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" [disabled]="!isView" id="isActive" formControlName="isActive" />
          <label class="form-check-label" for="isActive">
            {{ form.get('isActive')?.value ? 'เปิดใช้งาน' : 'ปิดการใช้งาน' }}
          </label>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isMultipleEquipment">
    <div class="col d-flex justify-content-end mb-2">
      <button type="button" *ngIf="!isView" class="btn btn-success" (click)="addMultitpleEquipment()">เพิ่มข้อมูล</button>
    </div>
    <div formArrayName="multipleEquipment">
      <div *ngFor="let fg of multipleEquipment.controls; let i = index" [formGroupName]="i" class="card card-body">
        <div class="col d-flex justify-content-end mb-2">
          <button type="button" *ngIf="!isView && i != 0" class="btn btn-danger" (click)="deleteMultipleEquipment(i)">ลบ</button>
        </div>
        <div class="col row mb-3">
          <label class="form-label col-12 align-self-center">ชื่อรายการย่อย:</label>
          <div class="col-12">
            <input type="text" class="form-control" formControlName="equipmentCustomName" [disabled]="!isView"
                   [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'equipmentCustomName'])}" />
          </div>
        </div>
        <div class="col row mb-3">
          <label class="form-label col-12 align-self-center">หมายเลข/ทะเบียน:</label>
          <div class="col-12">
            <input type="text" class="form-control" formControlName="equipmentNumber" [disabled]="!isView"
                  [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'equipmentNumber'])}" />
          </div>
        </div>
        <div class="col row mb-3">
          <div class="col-6">
            <label class="form-label col-md-12 align-self-center">ปีงบประมาณ</label>
            <ng-select class="custom" [items]="fiscalYear$ | async" bindLabel="title" bindValue="id"
                      placeholder="กรุณาเลือก" formControlName="fiscalYearId" [searchable]="true" [clearable]="false"
                      [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'fiscalYearId'])}"
                      [disabled]="!isView">
            </ng-select>
          </div>
          <div class="col-6">
            <label class="form-label col-12 align-self-center">วันที่รับเข้า</label>
            <div class="col-12">
              <input type="text" class="form-control"
                    placeholder="กรุณาเลือก"
                    bsDatepicker
                    formControlName="receiveDate"
                    [bsConfig]="{ dateInputFormat: 'DD MMMM YYYY' }"
                    [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'receiveDate'])}"
                    [disabled]="!isView" />
            </div>
          </div>
        </div>
        <div class="col row mb-3" *ngIf="isParcel">
          <div class="col-6">
            <label class="form-label col-md-12 align-self-center">ประเภทการจัดซื้อจัดจ้าง</label>
            <ng-select class="custom" [items]="procurementType$ | async" bindLabel="title" bindValue="id"
                      placeholder="กรุณาเลือก" formControlName="procurementTypeId" [searchable]="true" [clearable]="false"
                      [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'procurementTypeId'])}"
                      [disabled]="!isView">
            </ng-select>
          </div>
          <div class="col-6">
            <label class="form-label col-12 align-self-center">เลขที่สัญญา</label>
            <div class="col-12">
              <input type="text" class="form-control" formControlName="contractNo" [disabled]="!isView"
                    [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'contractNo'])}" />
            </div>
          </div>
        </div>
        <div class="col row mb-3" *ngIf="isParcel">
          <div class="col-6">
            <label class="form-label col-md-12 align-self-center">ลงวันที่</label>
            <input type="text" class="form-control"
                  placeholder="กรุณาเลือก"
                  bsDatepicker
                  formControlName="dated"
                  [bsConfig]="{ dateInputFormat: 'DD MMMM YYYY' }"
                  [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'dated'])}"
                  [disabled]="!isView" />
          </div>
          <div class="col-6">
            <label class="form-label col-12 align-self-center">เลขสินทรัพย์ในระบบ GFMIS</label>
            <div class="col-12">
              <input type="text" class="form-control" formControlName="assetNoGfmis" [disabled]="!isView"
                    [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'assetNoGfmis'])}" />
            </div>
          </div>
        </div>
        <div class="col row mb-3" *ngIf="isParcel">
          <div class="col-6">
            <label class="form-label col-md-12 align-self-center">ราคาต่อหน่วย</label>
            <input type="text" class="form-control" formControlName="pricePerUnit" [disabled]="!isView"
                  [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'pricePerUnit'])}" />
          </div>
          <div class="col-6">
            <label class="form-label col-12 align-self-center">งวดงาน/งวดงานทั้งหมด</label>
            <div class="col-12">
              <input type="text" class="form-control" formControlName="workPeriod" [disabled]="!isView"
                    [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'workPeriod'])}" />
            </div>
          </div>
        </div>
        <div class="col row">
          <div class="col-6">
            <label for="isActive" class="form-label">{{titleStatus}}</label>
            <div class="col-12">
              <ng-select class="custom" [items]="sharedService.manageParcalStatus" bindLabel="label" bindValue="value"
                        placeholder="กรุณาเลือก" [searchable]="true" [clearable]="true"
                        formControlName="equipmentStatus"
                        [ngClass]="{'is-invalid': isInvalid(['multipleEquipment', i, 'equipmentStatus'])}"
                        [disabled]="!isView">
              </ng-select>
            </div>
          </div>
          <div class="col-6">
            <label for="isActive" class="form-label">สถานะการใช้งาน</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" [disabled]="!isView" id="isActive" formControlName="isActive" />
              <label class="form-check-label" for="isActive">
                {{ form.get('isActive')?.value ? 'เปิดใช้งาน' : 'ปิดการใช้งาน' }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</div>
<div class="modal-footer">
  <button type="button" *ngIf="!isView" class="btn btn-success" (click)="onSave()">บันทึก</button>
  <button type="button" *ngIf="!isView"  class="btn btn-danger" (click)="closeModal()">ยกเลิก</button>
  <button type="button" *ngIf="isView"  class="btn btn-secondary" (click)="closeModal()">ปิด</button>
</div>
